import {type FC, useEffect, useState} from 'react';
import {
  useDeleteFollowCompany,
  useGetCompanyInfo,
  useUpdateFollowCompany,
} from '../../../../../../core/repositories/companiesRepository';
import {buildCompanyFollowGtmContent} from '../../../../../../shared/services/buildCompanyFollowGtmContent';
import {FollowCompanyButtonPresentation} from './presentation';

type Props = {
  className?: string;
  companyId: number;
};

export const FollowCompanyButtonContainer: FC<Props> = ({
  className,
  companyId,
}) => {
  const {data} = useGetCompanyInfo({companyId});
  const [isFollowing, setIsFollowing] = useState(false);
  const [followCount, setFollowCount] = useState(0);
  const [companyName, setCompanyName] = useState('');

  useEffect(() => {
    if (data?.ok) {
      setIsFollowing(data.value.followed);
      setFollowCount(data.value.followerCount);
      setCompanyName(data.value.name);
    } else {
      setIsFollowing(false);
      setFollowCount(0);
      setCompanyName('');
    }
  }, [data]);

  const follow = useUpdateFollowCompany({
    onSuccessFunc() {
      setIsFollowing(true);
      setFollowCount((prev) => prev + 1);
    },
  });
  const unfollow = useDeleteFollowCompany({
    onSuccessFunc() {
      setIsFollowing(false);
      setFollowCount((prev) => prev - 1);
    },
  });

  const handleFollowCompany = async () => {
    if (isFollowing) {
      await unfollow.mutateAsync({companyId});
      return;
    }
    await follow.mutateAsync({companyId});
  };

  return (
    <FollowCompanyButtonPresentation
      count={followCount}
      className={className}
      isFollowing={isFollowing}
      handleFollowCompany={handleFollowCompany}
      dataGtmContent={buildCompanyFollowGtmContent({
        companyId,
        companyName,
        location: 'columns-list-header',
      })}
    />
  );
};
